import React, {useMemo} from 'react';
import Editor from "@draft-js-plugins/editor";
import {EditorState, Entity, CompositeDecorator} from "draft-js";
import {ScEditorContentSmall} from "../editor/editor";
import {sc_editor_style_map} from "../editor/style-map";
import {extendedBlockRenderMap} from "../editor/rich-text-editor";
import {scEditorBlockRenderer} from "../editor/block-renderer";
//import {scPluginEmoji} from "../editor/plugins/emoji";
import {scPluginLinkify} from "../editor/plugins/linkify";
import {scPluginLink} from "../editor/plugins/anchor";
import {useIsMobile} from "../../../m3/hooks/is-mobile";

function findMergeTagEntities(contentBlock, callback) {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                Entity.get(entityKey).getType() === '{{mention'
            )
        },
        callback
    )
}

function findMentionEntities(contentBlock, callback) {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                Entity.get(entityKey).getType() === 'mention'
            )
        },
        callback
    )
}

function findLinkEntities(contentBlock, callback) {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                Entity.get(entityKey).getType() === 'LINK'
            )
        },
        callback
    )
}

const LinkEntity = (props) => {
    const data = Entity.get(props.entityKey).getData();
    const href = data?.href||data?.url||data?.value;
    return (
        <a href={href} target="_blank" className="color-link-reverse" rel="nofollow noreferrer">{props.children}</a>
    )
}

const Mention = (props) => {
    const data = Entity.get(props.entityKey).getData();
    return (
        <span>{props.children}</span>
    )
}

const MergeTag = (props) => {
    const data = Entity.get(props.entityKey).getData();
    if(data.mention&&data.mention.example) {
        return <span>{data.mention.example}</span>
    }
    return (
        <span >{props.children}</span>
    )
}

const _linkify_plugin = scPluginLinkify(true);

const _plugins = [_linkify_plugin]

export function SimpleDraftJsViewer({content_state=null,text_only,compact,block_preview_count,block_count,classes='prose prose-sm',style={}, ...rest}) {
const is_mobile = useIsMobile();
    const {fns = {
        onOpenImage: () => {},
    }} = rest;
    const decorator = new CompositeDecorator([
        { strategy: findLinkEntities, component: LinkEntity },
        { strategy: findMergeTagEntities, component: MergeTag },
        { strategy: findMentionEntities, component: Mention },
    ])
  //  const final_plugins = [scPluginLinkify(true), scPluginLink];

    const editorState = useMemo(()=>{
        return content_state ? EditorState.createWithContent(content_state, decorator) : EditorState.createEmpty(decorator);
    }, [content_state,decorator])

    return <ScEditorContentSmall className={classes} style={style}>
        <Editor
            key="preview"
            customStyleMap={sc_editor_style_map}
            readOnly={true}
            plugins={_plugins}
            blockRenderMap={extendedBlockRenderMap}
            blockRendererFn={scEditorBlockRenderer(()=>{}, true,editorState.getCurrentContent(), !is_mobile,{block_count,text_only,fns,compact:!!compact,block_preview_count})}
            editorState={editorState}
            onChange={(nes) => {}}
        />
    </ScEditorContentSmall>
}